(function () {
  'use strict';

  var isSafari =
    typeof navigator !== 'undefined' &&
    /Safari/i.test(navigator.userAgent) &&
    !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(navigator.userAgent);

  function getProductAddButton(root) {
    var scope = root || document;
    var hydeRoot = scope.matches && scope.matches('[data-hyde-pdp]') ? scope : scope.querySelector('[data-hyde-pdp]');

    if (hydeRoot) {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var hydeBtn = hydeRoot.querySelector(
        isMobile ? '.hyde-pdp__add-btn--mobile' : '.hyde-pdp__add-btn--desktop'
      );
      if (hydeBtn) return hydeBtn;
    }

    return scope.querySelector('.rabitat-product-page__add-btn');
  }

  function setProductAddButtonLoading(isLoading, root) {
    var btn = getProductAddButton(root);
    if (!btn) return;

    if (!btn.dataset.defaultLabel) {
      btn.dataset.defaultLabel = btn.getAttribute('data-default-label') || 'Add to Cart';
    }

    var soldOutLabel = btn.getAttribute('data-sold-out-label') || 'Sold out';

    if (isLoading) {
      btn.dataset.wasDisabled = btn.disabled ? 'true' : 'false';
      btn.disabled = true;
      btn.textContent = 'Adding...';
      btn.setAttribute('aria-busy', 'true');
      return;
    }

    btn.removeAttribute('aria-busy');
    var isSoldOut = btn.dataset.wasDisabled === 'true';
    btn.disabled = isSoldOut;
    btn.textContent = isSoldOut ? soldOutLabel : btn.dataset.defaultLabel;
  }

  function collectFormProperties(form) {
    var properties = {};
    if (!form) return properties;

    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    });

    return properties;
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (cart && typeof cart.item_count === 'number') {
      document.dispatchEvent(
        new CustomEvent('rabitat:cart:updated', {
          detail: { item_count: cart.item_count, cart: cart }
        })
      );
    }
  }

  function readCartCountFromHeader() {
    var countEl = document.querySelector('[data-rabitat-cart-count]');
    if (!countEl || countEl.hidden) return 0;
    return parseInt(countEl.textContent, 10) || 0;
  }

  function syncCartAfterAdd(lineItem) {
    if (window.RabitatCart && typeof window.RabitatCart.handleMutationResult === 'function') {
      window.RabitatCart.handleMutationResult(lineItem, {
        open: true,
        focus: false,
        animate: false
      });
      return;
    }

    var addedQty = lineItem && lineItem.quantity ? lineItem.quantity : 1;
    var optimisticCount = readCartCountFromHeader() + addedQty;

    if (window.RabitatCart && typeof window.RabitatCart.openDrawerForAdd === 'function') {
      window.RabitatCart.openDrawerForAdd({ open: true, focus: false, animate: false });
    } else if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer({ focus: false, animate: false });
    }

    if (window.RabitatCart && typeof window.RabitatCart.updateCartCount === 'function') {
      window.RabitatCart.updateCartCount(optimisticCount);
    }

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        notifyCartUpdated(cart);
      })
      .catch(function () {
        notifyCartUpdated({ item_count: optimisticCount });
      });
  }

  function finishAddToCart(lineItem, root) {
    setProductAddButtonLoading(false, root);
    syncCartAfterAdd(lineItem);
  }

  window.RabitatCart = window.RabitatCart || {};
  window.RabitatCart.setProductAddButtonLoading = setProductAddButtonLoading;
  window.RabitatCart.finishAddToCart = finishAddToCart;
  window.RabitatCart.syncCartAfterAdd = syncCartAfterAdd;
  window.RabitatCart.notifyUpdated = notifyCartUpdated;

  function initProductPage(root) {
    if (!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    var form = root.querySelector('.rabitat-product-page__form, .rabitat-product-page__controls');
    var variantInput = form && form.querySelector('[data-product-variant-id]');
    var quantityInput = form && form.querySelector('[data-product-quantity]');
    var priceEl = root.querySelector('[data-product-price]');
    var compareEl = root.querySelector('[data-product-compare]');
    var colourLabel = root.querySelector('[data-product-colour-label]');
    var mainImage = root.querySelector('.rabitat-product-page__hero-image');
    var heroContainer = root.querySelector('[data-product-hero]');
    var thumbsContainer = root.querySelector('[data-product-thumbs]');
    var thumbsArrow = root.querySelector('[data-product-thumbs-arrow]');
    var variantsJsonEl = root.querySelector('[data-product-variants]');
    var mediaJsonEl = root.querySelector('[data-product-media]');
    var boundariesJsonEl = root.querySelector('[data-product-media-boundaries]');
    var variantMediaRangesEl = root.querySelector('[data-product-variant-media-ranges]');
    var pincodeToggle = root.querySelector('[data-product-pincode-toggle]');
    var pincodePanel = root.querySelector('[data-product-pincode]');
    var productTitle = root.dataset.productTitle || 'Product image';
    var variants = [];
    var mediaCatalog = [];
    var mediaBoundaries = [];
    var variantMediaRanges = [];

    function resolveImageAlt(image) {
      if (image && image.alt) return image.alt;
      return productTitle;
    }

    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    if (mediaJsonEl) {
      try {
        mediaCatalog = JSON.parse(mediaJsonEl.textContent);
      } catch (e) {
        mediaCatalog = [];
      }
    }

    if (boundariesJsonEl) {
      try {
        mediaBoundaries = JSON.parse(boundariesJsonEl.textContent);
        mediaBoundaries.sort(function (a, b) {
          return a - b;
        });
      } catch (e) {
        mediaBoundaries = [];
      }
    }

    if (variantMediaRangesEl) {
      try {
        variantMediaRanges = JSON.parse(variantMediaRangesEl.textContent);
      } catch (e) {
        variantMediaRanges = [];
      }
    }

    if (pincodeToggle && pincodePanel) {
      pincodeToggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (pincodePanel.hidden) {
          pincodePanel.hidden = false;
          pincodeToggle.setAttribute('aria-expanded', 'true');
          if (window.RabitatEdd && window.RabitatEdd.revealPincodeResult) {
            window.RabitatEdd.revealPincodeResult(pincodePanel);
          }
          var input = pincodePanel.querySelector('.edd-calculator__input');
          if (input) input.focus();
        } else {
          pincodePanel.hidden = true;
          pincodeToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    initTimelineDates(root);
    initDescriptionToggle(root);

    function initDescriptionToggle(pageRoot) {
      var wrap = pageRoot.querySelector('[data-product-description]');
      if (!wrap || wrap.dataset.descriptionInitialized === 'true') return;
      wrap.dataset.descriptionInitialized = 'true';

      var content = wrap.querySelector('[data-product-description-content]');
      var toggle = wrap.querySelector('[data-product-description-toggle]');
      var moreLabel = wrap.querySelector('[data-product-description-more]');
      var lessLabel = wrap.querySelector('[data-product-description-less]');
      if (!content || !toggle) return;

      function syncToggleVisibility() {
        content.classList.add('is-collapsed');
        var needsToggle = content.scrollHeight > content.clientHeight + 1;

        if (!needsToggle) {
          content.classList.remove('is-collapsed');
          toggle.hidden = true;
          if (moreLabel) moreLabel.hidden = false;
          if (lessLabel) lessLabel.hidden = true;
          return;
        }

        toggle.hidden = false;
      }

      function setCollapsed(collapsed) {
        content.classList.toggle('is-collapsed', collapsed);
        if (moreLabel) moreLabel.hidden = !collapsed;
        if (lessLabel) lessLabel.hidden = collapsed;
      }

      setCollapsed(true);
      syncToggleVisibility();

      window.addEventListener('resize', syncToggleVisibility);

      toggle.addEventListener('click', function () {
        setCollapsed(content.classList.contains('is-collapsed') ? false : true);
      });
    }

    function ordinalSuffix(day) {
      if (day >= 11 && day <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    function formatTimelineDay(date) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[date.getMonth()] + ' ' + date.getDate() + ordinalSuffix(date.getDate());
    }

    function addCalendarDays(date, days) {
      var next = new Date(date.getTime());
      next.setDate(next.getDate() + days);
      return next;
    }

    function formatTimelineRange(start, end) {
      if (start.getMonth() === end.getMonth()) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[start.getMonth()] + ' ' + start.getDate() + ordinalSuffix(start.getDate()) + '-' + end.getDate() + ordinalSuffix(end.getDate());
      }
      return formatTimelineDay(start) + '-' + formatTimelineDay(end);
    }

    function hasSavedDeliveryDate() {
      try {
        var raw = localStorage.getItem('edd_delivery');
        if (!raw) return false;
        var data = JSON.parse(raw);
        return !!(data && data.deliveryDate);
      } catch (e) {
        return false;
      }
    }

    function initTimelineDates(pageRoot) {
      var delivery = pageRoot.querySelector('.rabitat-product-page__delivery');
      var timeline = pageRoot.querySelector('[data-product-timeline]');
      if (!timeline || !delivery) return;

      var deliveryDaysMin = parseInt(timeline.dataset.deliveryDaysMin, 10);
      var deliveryDaysMax = parseInt(timeline.dataset.deliveryDaysMax, 10);
      if (isNaN(deliveryDaysMin)) deliveryDaysMin = 5;
      if (isNaN(deliveryDaysMax)) deliveryDaysMax = 7;
      if (deliveryDaysMax < deliveryDaysMin) deliveryDaysMax = deliveryDaysMin;

      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var tomorrow = addCalendarDays(today, 1);
      var deliveryStart = addCalendarDays(today, deliveryDaysMin);
      var deliveryEnd = addCalendarDays(today, deliveryDaysMax);
      var defaultDeliveryText = formatTimelineRange(deliveryStart, deliveryEnd);

      var orderEl = delivery.querySelector('[data-product-timeline-order-date]');
      var shipEl = delivery.querySelector('[data-product-timeline-ship-date]');
      var deliveryEl = delivery.querySelector('[data-product-timeline-delivery-date]');

      if (orderEl) orderEl.textContent = formatTimelineDay(today);
      if (shipEl) shipEl.textContent = formatTimelineDay(tomorrow);

      if (deliveryEl) {
        deliveryEl.setAttribute('data-default-date', defaultDeliveryText);
        if (!hasSavedDeliveryDate()) {
          deliveryEl.textContent = defaultDeliveryText;
        }
      }
    }

    function findVariant(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    function getHeroViewport() {
      return heroContainer ? heroContainer.querySelector('[data-product-hero-viewport]') : null;
    }

    function getHeroTrack() {
      return heroContainer ? heroContainer.querySelector('[data-product-hero-track]') : null;
    }

    function getHeroImage() {
      if (heroContainer) {
        return heroContainer.querySelector('.rabitat-product-page__hero-image:not(.rabitat-product-page__hero-image--placeholder)');
      }
      return mainImage;
    }

    function setMainImage(src, alt) {
      var img = getHeroImage();
      if (!img || !src) return;

      if (window.RabitatResponsiveImage) {
        window.RabitatResponsiveImage.apply(img, src, {
          preset: 'product',
          loading: 'eager',
          alt: alt || img.alt || productTitle,
        });
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        img.alt = alt || img.alt || productTitle;
      }

      img.hidden = false;
      img.loading = 'eager';
    }

    function scrollHeroToIndex(index, smooth) {
      var viewport = getHeroViewport();
      var track = getHeroTrack();
      var slides = track ? track.querySelectorAll('[data-product-hero-slide]') : [];
      if (!viewport || !track || !slides.length) return;

      var slide = slides[index];
      if (!slide) return;

      viewport.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    function syncThumbActive(activeIndex) {
      getThumbButtons().forEach(function (btn, index) {
        var isActive = index === activeIndex;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function bindHeroScroll() {
      var viewport = getHeroViewport();
      if (!viewport || viewport.dataset.heroScrollBound === 'true') return;
      viewport.dataset.heroScrollBound = 'true';

      var heroScrollTicking = false;

      viewport.addEventListener(
        'scroll',
        function () {
          if (!isHorizontalThumbs()) return;
          if (heroScrollTicking) return;
          heroScrollTicking = true;
          window.requestAnimationFrame(function () {
            heroScrollTicking = false;

            var track = getHeroTrack();
            var slides = track ? track.querySelectorAll('[data-product-hero-slide]') : [];
            if (!slides.length) return;

            var scrollLeft = viewport.scrollLeft;
            var nearestIndex = 0;
            var nearestDistance = Infinity;

            slides.forEach(function (slide, index) {
              var distance = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            syncThumbActive(nearestIndex);
          });
        },
        { passive: true }
      );
    }

    function renderHeroGallery(images, activeIndex) {
      var track = getHeroTrack();
      if (!track) return;

      var uniqueImages = dedupeImages(images);
      if (!uniqueImages.length) return;

      activeIndex = activeIndex || 0;

      if (isHorizontalThumbs()) {
        track.innerHTML = '';

        uniqueImages.forEach(function (image, index) {
          var slide = document.createElement('div');
          slide.className = 'rabitat-product-page__hero-slide';
          slide.setAttribute('data-product-hero-slide', '');

          var img = document.createElement('img');
          img.className = 'rabitat-product-page__hero-image';
          img.alt = resolveImageAlt(image);
          img.loading = index === 0 ? 'eager' : 'lazy';
          if (window.RabitatResponsiveImage) {
            window.RabitatResponsiveImage.apply(img, image.full, {
              preset: 'product',
              loading: img.loading,
              alt: img.alt,
            });
          } else {
            img.src = image.full;
          }
          slide.appendChild(img);
          track.appendChild(slide);
        });

        bindHeroScroll();
        window.requestAnimationFrame(function () {
          scrollHeroToIndex(activeIndex, false);
        });
        return;
      }

      var image = uniqueImages[activeIndex] || uniqueImages[0];
      track.innerHTML = '';

      if (!image) return;

      var desktopImg = document.createElement('img');
      desktopImg.className = 'rabitat-product-page__hero-image';
      desktopImg.alt = resolveImageAlt(image);
      desktopImg.loading = 'eager';
      if (window.RabitatResponsiveImage) {
        window.RabitatResponsiveImage.apply(desktopImg, image.full, {
          preset: 'product',
          loading: 'eager',
          alt: desktopImg.alt,
        });
      } else {
        desktopImg.src = image.full;
      }
      track.appendChild(desktopImg);
    }

    function mediaIndexById(mediaId) {
      if (!mediaId) return -1;
      for (var i = 0; i < mediaCatalog.length; i++) {
        if (String(mediaCatalog[i].id) === String(mediaId)) {
          return i;
        }
      }
      return -1;
    }

    function resolveVariantMediaIndex(variant) {
      if (!variant) return -1;
      if (variant.featured_media_index != null) {
        return variant.featured_media_index;
      }
      return mediaIndexById(variant.featured_media_id);
    }

    function getVariantMediaBoundaryIndices() {
      if (variantMediaRanges.length) {
        var rangeBoundaries = variantMediaRanges
          .map(function (range) {
            return range.start;
          })
          .filter(function (index) {
            return index != null && index >= 0;
          });

        rangeBoundaries.sort(function (a, b) {
          return a - b;
        });

        return rangeBoundaries.filter(function (index, position, list) {
          return position === 0 || index !== list[position - 1];
        });
      }

      if (mediaBoundaries.length) {
        return mediaBoundaries;
      }

      var seen = {};
      var boundaries = [];

      variants.forEach(function (variant) {
        var index = resolveVariantMediaIndex(variant);
        if (index < 0 || seen[index]) return;
        seen[index] = true;
        boundaries.push(index);
      });

      boundaries.sort(function (a, b) {
        return a - b;
      });

      return boundaries;
    }

    function getUnavailableMediaIndexSet(selectedVariantId) {
      var blocked = {};

      variantMediaRanges.forEach(function (range) {
        if (range.available) return;
        if (String(range.id) === String(selectedVariantId)) return;
        if (range.start == null || range.end == null) return;

        for (var index = range.start; index < range.end; index++) {
          blocked[index] = true;
        }
      });

      return blocked;
    }

    function filterUnavailableVariantImages(images, selectedVariantId) {
      if (!variantMediaRanges.length || !images.length) {
        return images;
      }

      var blocked = getUnavailableMediaIndexSet(selectedVariantId);

      return images.filter(function (image) {
        var index = image.index;

        if (index == null) {
          index = mediaIndexById(image.id);
        }

        if (index < 0) return true;
        return !blocked[index];
      });
    }

    function imagesForVariant(variantId) {
      if (!mediaCatalog.length) return [];

      var variant = findVariant(variantId);
      if (!variant) return [];

      var images = [];

      if (variant.media_indices && variant.media_indices.length) {
        images = variant.media_indices
          .map(function (index) {
            return mediaCatalog[index];
          })
          .filter(Boolean);
      } else if (
        variant.media_start_index != null &&
        variant.media_end_index != null &&
        variant.media_end_index > variant.media_start_index
      ) {
        images = mediaCatalog.slice(variant.media_start_index, variant.media_end_index);
      } else {
        var start = resolveVariantMediaIndex(variant);

        if (start < 0) {
          if (variant.featured_media_id) {
            var featuredIndex = mediaIndexById(variant.featured_media_id);
            if (featuredIndex >= 0) {
              images = [mediaCatalog[featuredIndex]];
            }
          }

          if (!images.length && variant.featured_image_full) {
            var featuredMatch = mediaCatalog.filter(function (image) {
              return image.full === variant.featured_image_full;
            });
            if (featuredMatch.length) {
              images = featuredMatch;
            } else {
              images = [
                {
                  id: variant.featured_image_full,
                  full: variant.featured_image_full,
                  thumb: variant.featured_image_full,
                  alt: productTitle,
                },
              ];
            }
          }

          if (!images.length) {
            images = mediaCatalog.length ? [mediaCatalog[0]] : [];
          }
        } else {
          var boundaries = getVariantMediaBoundaryIndices();
          var end = mediaCatalog.length;

          boundaries.some(function (boundary) {
            if (boundary > start) {
              end = boundary;
              return true;
            }
            return false;
          });

          images = mediaCatalog.slice(start, end);
        }
      }

      return filterUnavailableVariantImages(images, variantId);
    }

    function dedupeImages(images) {
      var seen = {};
      return (images || []).filter(function (image) {
        var key = String(image.id || image.full);
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function normalizeGallerySrc(src) {
      return String(src || '')
        .replace(/^https?:/i, '')
        .replace(/&amp;/g, '&')
        .trim();
    }

    function getThumbButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
    }

    function getActiveThumbIndex(thumbs) {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function selectThumbByIndex(index) {
      var thumbs = getThumbButtons();
      if (!thumbs.length) return;

      var nextIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[nextIndex];

      if (isHorizontalThumbs()) {
        scrollHeroToIndex(nextIndex, true);
      } else {
        setMainImage(thumb.dataset.fullSrc, thumb.dataset.alt || '');
      }

      syncThumbActive(nextIndex);

      if (isHorizontalThumbs()) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }

      updateHeroArrowVisibility();
    }

    function updateHeroArrowVisibility() {
      var heroPrev = root.querySelector('[data-product-hero-prev]');
      var heroNext = root.querySelector('[data-product-hero-next]');

      if (heroPrev) {
        heroPrev.hidden = true;
        heroPrev.setAttribute('aria-hidden', 'true');
      }

      if (heroNext) {
        heroNext.hidden = true;
        heroNext.setAttribute('aria-hidden', 'true');
      }
    }

    function isHorizontalThumbs() {
      if (!thumbsContainer) return false;
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function scrollThumbsToStart() {
      if (!thumbsContainer) return;
      if (isHorizontalThumbs()) {
        if (typeof thumbsContainer.scrollTo === 'function') {
          thumbsContainer.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          thumbsContainer.scrollLeft = 0;
        }
      } else if (typeof thumbsContainer.scrollTo === 'function') {
        thumbsContainer.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        thumbsContainer.scrollTop = 0;
      }
      updateThumbsArrowVisibility();
    }

    function updateThumbsArrowVisibility() {
      updateHeroArrowVisibility();

      if (!thumbsArrow || !thumbsContainer) return;

      if (isHorizontalThumbs()) {
        thumbsArrow.hidden = true;
        thumbsArrow.setAttribute('aria-hidden', 'true');
        return;
      }

      var imageCount = thumbsContainer.querySelectorAll('[data-product-thumb]').length;
      var canScroll = imageCount > 6;

      if (!canScroll) {
        thumbsArrow.hidden = true;
        thumbsArrow.setAttribute('aria-hidden', 'true');
        return;
      }

      thumbsArrow.hidden = false;
      thumbsArrow.setAttribute('aria-hidden', 'false');

      var atEnd =
        thumbsContainer.scrollTop + thumbsContainer.clientHeight >=
        thumbsContainer.scrollHeight - 4;

      thumbsArrow.style.opacity = atEnd ? '0' : '1';
    }

    function bindThumbsScroll() {
      if (!thumbsContainer || thumbsContainer.dataset.thumbsScrollBound === 'true') return;
      thumbsContainer.dataset.thumbsScrollBound = 'true';
      thumbsContainer.addEventListener('scroll', updateThumbsArrowVisibility);
      window.addEventListener('resize', updateThumbsArrowVisibility);
    }

    function renderThumbs(images, options) {
      if (!thumbsContainer) return;

      options = options || {};
      var uniqueImages = dedupeImages(images);

      if (options.skipIfUnchanged && uniqueImages.length) {
        var existingThumbs = getThumbButtons();
        if (existingThumbs.length) {
          var existingSignature = existingThumbs
            .map(function (btn) {
              return normalizeGallerySrc(btn.dataset.fullSrc);
            })
            .join('|');
          var newSignature = uniqueImages
            .map(function (image) {
              return normalizeGallerySrc(image.full);
            })
            .join('|');

          if (existingSignature === newSignature) {
            bindThumbsScroll();
            bindHeroScroll();

            var track = getHeroTrack();
            var slideCount = track ? track.querySelectorAll('[data-product-hero-slide]').length : 0;
            var prerenderedSlidesMatch = slideCount === uniqueImages.length;

            if (isHorizontalThumbs()) {
              if (!prerenderedSlidesMatch) {
                renderHeroGallery(uniqueImages, 0);
              } else {
                scrollHeroToIndex(0, false);
              }
            } else {
              var activeIndex = getActiveThumbIndex(existingThumbs);
              var slideNodes = track ? track.querySelectorAll('[data-product-hero-slide]') : [];

              if (!prerenderedSlidesMatch || slideNodes.length > 1) {
                renderHeroGallery(uniqueImages, activeIndex);
              }
            }

            requestAnimationFrame(updateThumbsArrowVisibility);
            return;
          }
        }
      }

      function applyGalleryUpdate() {
        if (isSafari && uniqueImages.length) {
          uniqueImages.forEach(function (image) {
            if (!image || !image.full) return;
            var preload = new Image();
            preload.decoding = 'async';
            preload.src = image.full;
          });
        }

        thumbsContainer.innerHTML = '';

        if (!uniqueImages.length) {
          return;
        }

        uniqueImages.forEach(function (image, index) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rabitat-product-page__thumb' + (index === 0 ? ' is-active' : '');
          btn.setAttribute('data-product-thumb', '');
          btn.dataset.fullSrc = image.full;
          btn.dataset.alt = resolveImageAlt(image);
          btn.setAttribute('aria-label', 'Show image ' + (index + 1));
          btn.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

          var img = document.createElement('img');
          img.src = image.thumb;
          img.alt = '';
          img.loading = index === 0 ? 'eager' : 'lazy';
          btn.appendChild(img);
          thumbsContainer.appendChild(btn);
        });

        scrollThumbsToStart();
        bindThumbsScroll();
        renderHeroGallery(uniqueImages, 0);
        requestAnimationFrame(updateThumbsArrowVisibility);
      }

      applyGalleryUpdate();
    }

    function scrollToGallery() {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      var media = root.querySelector('.rabitat-product-page__media');
      if (!media) return;

      media.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function isProductFullySoldOut() {
      if (root.dataset.productAvailable === 'false') return true;
      return !variants.some(function (v) {
        return v.available;
      });
    }

    function updatePurchaseActions(variant) {
      var isHydePdp = root.hasAttribute('data-hyde-pdp');
      var variantSignupWhenUnavailable = root.hasAttribute('data-variant-signup-when-unavailable');
      var addBtns = isHydePdp
        ? root.querySelectorAll('.rabitat-product-page__add-btn')
        : [getProductAddButton(root)].filter(Boolean);
      var addBtn = addBtns[0] || null;
      var actions = root.querySelector('[data-product-actions]');
      var buyNow = root.querySelector('#gokwik-buy-now') || root.querySelector('[data-gokwik-buy-now-trigger]');
      var signupTrigger = root.querySelector('[data-signup-trigger]');
      if (!addBtn && !buyNow && !signupTrigger) return;

      var defaultLabel = addBtn ? addBtn.getAttribute('data-default-label') || 'Add to Cart' : 'Add to Cart';
      var soldOutLabel = addBtn ? addBtn.getAttribute('data-sold-out-label') || 'Sold out' : 'Sold out';
      var productSoldOut = isProductFullySoldOut();
      var checkoutAvailable =
        variant && variant.checkout_available != null ? !!variant.checkout_available : !!(variant && variant.available);
      var isAvailable = !!(variant && variant.available);
      var showBuyNow = checkoutAvailable && !productSoldOut;

      if (variantSignupWhenUnavailable && signupTrigger) {
        var cartBtn =
          root.querySelector('.rabitat-product-page__add-btn[name="add"]') ||
          root.querySelector('.rabitat-product-page__add-btn:not([data-signup-trigger]):not([data-gokwik-buy-now-trigger])');
        var blinkitBtn = root.querySelector('.rabitat-product-page__blinkit-btn');

        if (isAvailable) {
          signupTrigger.hidden = true;

          if (cartBtn) {
            cartBtn.hidden = false;
            cartBtn.disabled = false;
            cartBtn.textContent = cartBtn.getAttribute('data-default-label') || defaultLabel;
            cartBtn.dataset.wasDisabled = 'false';
          }

          if (buyNow) {
            buyNow.hidden = false;
            buyNow.disabled = !showBuyNow;
            if (showBuyNow) {
              buyNow.removeAttribute('aria-disabled');
              buyNow.textContent =
                buyNow.getAttribute('data-product-buy-now-label') ||
                buyNow.getAttribute('data-rabitat-buy-now-label') ||
                'Buy Now';
            } else {
              buyNow.setAttribute('aria-disabled', 'true');
              buyNow.textContent = soldOutLabel;
            }

            var checkoutVariantId = variant && (variant.checkout_id || variant.id);
            if (checkoutVariantId) {
              buyNow.setAttribute('data-current-variant-id', String(checkoutVariantId));
            }
          }

          if (blinkitBtn) {
            blinkitBtn.hidden = false;
          }
        } else {
          signupTrigger.hidden = false;

          if (cartBtn) {
            cartBtn.hidden = true;
            cartBtn.disabled = true;
            cartBtn.dataset.wasDisabled = 'true';
          }

          if (buyNow) {
            buyNow.hidden = true;
            buyNow.disabled = true;
            buyNow.setAttribute('aria-disabled', 'true');
          }

          if (blinkitBtn) {
            blinkitBtn.hidden = true;
          }
        }

        if (actions) {
          actions.classList.toggle('rabitat-product-page__actions--sold-out', !isAvailable);
        }

        signupTrigger.setAttribute('data-current-variant-id', String(variant.id));
        return;
      }

      if (!addBtn && !buyNow) return;

      addBtns.forEach(function (currentBtn) {
        if (!currentBtn) return;

        currentBtn.dataset.defaultLabel = defaultLabel;
        var hydeAddLabel = currentBtn.querySelector('[data-hyde-add-btn-label]');

        if (isAvailable) {
          currentBtn.disabled = false;
          if (hydeAddLabel) {
            hydeAddLabel.textContent = defaultLabel;
          } else {
            currentBtn.textContent = defaultLabel;
          }
          currentBtn.dataset.wasDisabled = 'false';
          if (actions) actions.classList.remove('rabitat-product-page__actions--sold-out');
        } else {
          currentBtn.disabled = true;
          if (hydeAddLabel) {
            hydeAddLabel.textContent = soldOutLabel;
          } else {
            currentBtn.textContent = soldOutLabel;
          }
          currentBtn.dataset.wasDisabled = 'true';
          if (actions) actions.classList.add('rabitat-product-page__actions--sold-out');
        }
      });

      var customisableBadge = root.querySelector('[data-hyde-customisable-badge]');
      if (customisableBadge) {
        customisableBadge.hidden = !isAvailable;
      }

      if (!addBtn && actions && !isAvailable) {
        actions.classList.add('rabitat-product-page__actions--sold-out');
      } else if (!addBtn && actions) {
        actions.classList.remove('rabitat-product-page__actions--sold-out');
      }

      if (buyNow) {
        var buyNowLabel =
          buyNow.getAttribute('data-product-buy-now-label') ||
          buyNow.getAttribute('data-rabitat-buy-now-label') ||
          'Buy Now';

        if (buyNow.hasAttribute('data-gokwik-buy-now-trigger')) {
          var checkoutVariantId = variant && (variant.checkout_id || variant.id);
          if (checkoutVariantId) {
            buyNow.setAttribute('data-current-variant-id', String(checkoutVariantId));
          }

          buyNow.disabled = !showBuyNow;
          if (!showBuyNow) {
            buyNow.setAttribute('aria-disabled', 'true');
            buyNow.textContent = soldOutLabel;
          } else {
            buyNow.removeAttribute('aria-disabled');
            buyNow.textContent = buyNowLabel;
          }
        } else {
          buyNow.hidden = !showBuyNow;
          buyNow.style.display = showBuyNow ? '' : 'none';
          buyNow.disabled = !showBuyNow;
        }
      }
    }

    function selectVariant(variant, options) {
      options = options || {};
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) {
        priceEl.textContent = variant.price_formatted || '';
      }

      if (compareEl) {
        if (variant.compare_at_price > variant.price && variant.compare_formatted) {
          compareEl.textContent = variant.compare_formatted;
          compareEl.hidden = false;
          compareEl.classList.remove('rabitat-product-page__compare--hidden');
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
          compareEl.classList.add('rabitat-product-page__compare--hidden');
        }
      }

      root.querySelectorAll('[data-product-colour-label]').forEach(function (el) {
        if (variant.option1) {
          el.textContent = variant.option1;
        }
      });

      var variantImages = imagesForVariant(variant.id);
      var galleryInitialized = root.dataset.galleryInitialized === 'true';
      renderThumbs(variantImages, {
        skipIfUnchanged: !galleryInitialized && root.dataset.galleryPrerendered === 'true',
      });
      root.dataset.galleryInitialized = 'true';

      root.querySelectorAll('[data-product-swatch]').forEach(function (btn) {
        var isActive = String(btn.value) === String(variant.id);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      updatePurchaseActions(variant);

      var signupTrigger = root.querySelector('[data-signup-trigger]');
      if (signupTrigger && variant) {
        signupTrigger.setAttribute('data-current-variant-id', String(variant.id));
      }

      document.dispatchEvent(
        new CustomEvent('rabitat:variant:changed', {
          detail: { variant: variant }
        })
      );

      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: { variant: variant }
        })
      );

      if (options.scrollToGallery) {
        scrollToGallery();
      }
    }

    root.addEventListener('click', function (event) {
      var heroPrev = event.target.closest('[data-product-hero-prev]');
      if (heroPrev && root.contains(heroPrev)) {
        event.preventDefault();
        selectThumbByIndex(getActiveThumbIndex(getThumbButtons()) - 1);
        return;
      }

      var heroNext = event.target.closest('[data-product-hero-next]');
      if (heroNext && root.contains(heroNext)) {
        event.preventDefault();
        selectThumbByIndex(getActiveThumbIndex(getThumbButtons()) + 1);
        return;
      }

      var thumb = event.target.closest('[data-product-thumb]');
      if (thumb && root.contains(thumb)) {
        event.preventDefault();
        var thumbs = getThumbButtons();
        var thumbIndex = thumbs.indexOf(thumb);
        if (thumbIndex >= 0) {
          selectThumbByIndex(thumbIndex);
        }
        return;
      }

      var swatch = event.target.closest('[data-product-swatch]');
      if (swatch && root.contains(swatch)) {
        event.preventDefault();
        selectVariant(findVariant(swatch.value), { scrollToGallery: true });
        return;
      }

      var qtyMinus = event.target.closest('[data-product-qty-minus]');
      if (qtyMinus && quantityInput) {
        event.preventDefault();
        var next = Math.max(1, parseInt(quantityInput.value, 10) - 1 || 1);
        quantityInput.value = next;
        root.querySelector('[data-product-qty-value]').textContent = next;
        return;
      }

      var qtyPlus = event.target.closest('[data-product-qty-plus]');
      if (qtyPlus && quantityInput) {
        event.preventDefault();
        var plusNext = Math.max(1, parseInt(quantityInput.value, 10) + 1 || 2);
        quantityInput.value = plusNext;
        root.querySelector('[data-product-qty-value]').textContent = plusNext;
        return;
      }

      var gokwikTrigger = event.target.closest('[data-gokwik-buy-now-trigger]');
      if (gokwikTrigger && root.contains(gokwikTrigger)) {
        event.preventDefault();
        if (gokwikTrigger.disabled || gokwikTrigger.getAttribute('aria-disabled') === 'true') return;

        var gokwikVariantId = gokwikTrigger.getAttribute('data-current-variant-id');
        if (window.RabitatGokwikCheckout && window.RabitatGokwikCheckout.buyNowWithVariant) {
          window.RabitatGokwikCheckout.buyNowWithVariant(gokwikVariantId, gokwikTrigger);
        } else {
          window.alert('Checkout is loading. Please try again in a moment.');
        }
        return;
      }

      var signupTrigger = event.target.closest('[data-signup-trigger]');
      if (signupTrigger && root.contains(signupTrigger)) {
        event.preventDefault();

        var signupSection = root.closest('[data-signup-collection]');
        var variantId = signupTrigger.getAttribute('data-current-variant-id');
        var selectedVariant = findVariant(variantId) || variants[0];

        document.dispatchEvent(
          new CustomEvent('rabitat:signup:open', {
            detail: {
              productId: root.getAttribute('data-product-id') || '',
              productTitle: root.getAttribute('data-product-title') || '',
              productHandle: root.getAttribute('data-product-handle') || '',
              variant: selectedVariant,
              sectionRoot: signupSection,
            },
          })
        );
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'add') return;

        event.preventDefault();
        if (submitter.disabled || !variantInput || !quantityInput) return;

        setProductAddButtonLoading(true, root);

        var addPayload = {
          id: variantInput.value,
          quantity: Math.max(1, parseInt(quantityInput.value, 10) || 1),
          properties: collectFormProperties(form)
        };

        if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
          addPayload = window.RabitatCart.withCartSections(addPayload);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addPayload)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'Add to cart failed');
              });
            }
            return response.json();
          })
          .then(function (lineItem) {
            finishAddToCart(lineItem, root);
          })
          .catch(function () {
            alert('Unable to add to cart. Please try again.');
          })
          .finally(function () {
            setProductAddButtonLoading(false, root);
          });
      });
    }

    if (variantInput) {
      selectVariant(findVariant(variantInput.value));
    }

    window.addEventListener('resize', function () {
      var images = dedupeImages(
        getThumbButtons().map(function (btn) {
          return {
            full: btn.dataset.fullSrc,
            alt: btn.dataset.alt || '',
            id: btn.dataset.fullSrc,
          };
        })
      );

      if (images.length) {
        var activeIndex = getActiveThumbIndex(getThumbButtons());
        renderHeroGallery(images, activeIndex);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-page]').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-page]').forEach(initProductPage);
  });
})();
